'use client'
import dynamic from 'next/dynamic'
import PropTypes from 'prop-types'
import React, { useRef } from 'react'

import CustomLink from '@/shared/components/customLink'
import useWindowSize from '@/shared/hooks/windowSize'
import { getSlugUrl } from '@/shared/utils'
import CommentaryCommonBox from '../commentaryCommonBox'
const EndOver = dynamic(() => import('./endover'))

type CommentaryProps = {
  data?: any
  inning?: any
}

const Commentary = ({ data, inning }: CommentaryProps) => {
  const [width] = useWindowSize()
  const previousId: { current: any } = useRef()
  let overEnd = -1
  let banInd = -1

  return (
    <>
      <section className={`sm:rounded-xl overflow-hidden my-3`}>
        {data?.map((over: any, index: any, item: any) => {
          const oWicketBatter = over?.oWicketBatter
          previousId.current = item[index - 1]

          if (['bai', 'bao', 'bam', 'boi', 'tm'].includes(over?.eEvent)) return null

          if (over?.eEvent === 'oe' || over?.eEvent === 'ie') {
            ++overEnd
            if (overEnd % 2 === 0) {
              ++banInd
              if ((width && width < 768 && banInd > 5) || (width && width > 767 && banInd > 2)) {
                banInd = 0
              }
            }
          }

          if (over?.sEventId !== '0-1' && over?.sEventId !== '0') {
            return (
              <>
                {item[index - 1] && item?.[index - 1]?.nInningNumber !== over?.nInningNumber && (
                  <p className="py-2 text-center bg-widget border border-tabBorder text-primary-500">
                    End Of Inning - {over?.nInningNumber}
                  </p>
                )}
                <div
                  key={`${index}-${over?.sOver}-${over?.nInningNumber}`}
                  id={`${index}-${over?.sOver}-${over?.nInningNumber}`}
                  className={` group bg-transparent sm:border-x border-tabBorder overflow-hidden ${index} ${
                    over?.eEvent === 'oe' && 'border-t-0 mt-6 sm:rounded-t-xl bg-transparent'
                  } ${
                    over?.sBall === '1' &&
                    (item[index + 1]?.eEvent !== 'oe' ||
                      item[index + 1]?.eEvent === 'to' ||
                      item[index + 1]?.eEvent === 'p11' ||
                      !item[index + 1]?.eEvent) &&
                    ' border-t border-t-tabBorder group/item'
                  } ${over?.nInningNumber === 1 && 'nInning1'} ${item[index + 1]?.eEvent === 'oe' ? 'sm:rounded-b-xl border-b border-tabBorder' : ''} ${
                    over?.nInningNumber === 2 && 'nInning2'
                  } ${over?.nInningNumber === 3 && 'nInning3'} ${over?.nInningNumber === 4 && 'nInning4'} ${(data?.[index + 1]?.eEvent === 'oe' || data?.[index + 1]?.eEvent === 'ie') && !over?.sText ? 'pb-4' : ''}`}
                >
                  {over?.eEvent !== 'oe' && over?.eEvent !== 'ie' && (
                    <div
                      className={`${
                        over?.sComSummary ? 'items-start' : 'items-center'
                      } group-enabled/item:border-b-0 sm:border-0 border-b border-tabBorder py-4 sm:pb-0 md:px-6 sm:pt-7 flex gap-3`}
                      id={over?.sEventId}
                    >
                      <div className={`flex flex-col-reverse text-center gap-2.5`}>
                        {over?.sScore === '0' && (
                          <div
                            className={`${'my-0 py-0.5 px-1 w-7 h-7 text-base flex items-center justify-center'} rounded-full border border-tabBorder bg-transparent font-medium`}
                          >
                            {over?.sScore}
                          </div>
                        )}
                        {over?.sScore !== 'w' &&
                          ((over?.nRuns > 0 && over?.nRuns < 4) ||
                            over?.nRuns === 5 ||
                            over?.nRuns > 6) && (
                            <div
                              className={`${'my-0 py-0.5 px-1 w-7 h-7 text-base flex items-center justify-center'} ${
                                over?.sScore?.length > 1 &&
                                'text-xs md:min-w-[32px] md:h-8 md:text-xxs md:leading-7'
                              } rounded-full border border-tabBorder bg-transparent font-medium`}
                            >
                              {over?.sScore}
                            </div>
                          )}
                        {(over?.sScore === '4b' || over?.sScore === '4lb') && (
                          <div
                            className={`${'my-0 py-0.5 px-1 w-7 h-7 text-base flex items-center justify-center'} rounded-full border border-tabBorder bg-transparent font-medium`}
                          >
                            {over?.sScore}
                          </div>
                        )}
                        {over?.sScore === 'w' && (
                          <div
                            className={`${'my-0 py-0.5 px-1 w-7 h-7 text-base flex items-center justify-center'} rounded-full bg-WicketBg border-WicketBg text-white`}
                          >
                            {over?.sScore.toUpperCase()}
                          </div>
                        )}
                        {over?.sScore === '4' && (
                          <div
                            className={`${'my-0 py-0.5 px-1 w-7 h-7 text-base flex items-center justify-center'} rounded-full border bg-blueScore border-blueScore text-white`}
                          >
                            {over?.sScore.toUpperCase()}
                          </div>
                        )}
                        {over?.sScore === '6' && (
                          <div
                            className={`${'my-0 py-0.5 px-1 w-7 h-7 text-base flex items-center justify-center'} rounded-full border border-blueScore bg-blueScore text-white`}
                          >
                            {over?.sScore.toUpperCase()}
                          </div>
                        )}
                        <span className={`text-sm sm:text-lg text-textOffWhite font-medium`}>
                          {over?.sOver}
                          {over?.sBall && '.' + over?.sBall}{' '}
                        </span>
                      </div>
                      <div
                        className={`sm:pb-7 border-borderStroke flex-grow ${data[index + 1]?.eEvent === 'oe' || data[index + 1]?.eEvent === 'ie' ? 'sm:border-b-0' : 'sm:border-b'}`}
                      >
                        <p
                          className={`mb-0 ${['w', '4', '6'].includes(over?.sScore) ? '' : 'font-medium text-textOffWhite text-sm sm:text-lg'}`}
                        >
                          {over?.sComSummary}{' '}
                          {over?.eEvent === 'w' && (
                            <b>
                              {over?.oWicketBatter !== null &&
                                (oWicketBatter?.eTagStatus === 'a' &&
                                oWicketBatter?.oSeo?.eStatus === 'a' &&
                                oWicketBatter?.oSeo?.sSlug ? (
                                  <CustomLink href={getSlugUrl(`/${oWicketBatter?.oSeo?.sSlug}`)}>
                                    {over?.oWicketBatter?.sFullName ||
                                      over?.oWicketBatter?.sShortName}
                                  </CustomLink>
                                ) : (
                                  over?.oWicketBatter?.sFullName || over?.oWicketBatter?.sShortName
                                ))}{' '}
                              {`${over?.nBatterRuns}(${over?.nBatterBalls})`}
                            </b>
                          )}{' '}
                          <b>{over?.sHowOut !== null && over?.sHowOut}</b>
                        </p>
                        {over?.sText ? (
                          <div
                            className={`mb-0 mt-2.5 ${['w', '4', '6'].includes(over?.sScore) ? 'text-t-origin text-xs sm:text-base' : 'text-textDselected text-xs sm:text-base'}`}
                            dangerouslySetInnerHTML={{ __html: over?.sText }}
                          ></div>
                        ) : null}
                      </div>
                    </div>
                  )}
                  {(over?.eEvent === 'oe' || over?.eEvent === 'ie') && (
                    <>
                      <EndOver
                        key={`${over?._id}-${over?.sOver}${over?.nInningNumber}`}
                        data={over}
                        id={`${over?._id}-${over?.sOver}${over?.nInningNumber}`}
                        inning={inning}
                        isFirst={index === 0}
                      />
                    </>
                  )}
                  {over?.sEventId === '1' && over?.nInningNumber !== 1 && (
                    <h3 className="text-lg mt-3 text-primary-500 text-uppercase">End Of Inning</h3>
                  )}
                </div>
              </>
            )
          } else if (over?.sEventId === '0' && over?.sComSummary) {
            // for Toss detail
            return (
              <React.Fragment key={`comm${over?.sEventId}`}>
                <CommentaryCommonBox
                  id={`${over?._id}${over?.sOver}${over?.nInningNumber}`}
                  className="mt-3"
                  title={'Toss Detail'}
                >
                  {over?.sComSummary}
                </CommentaryCommonBox>
              </React.Fragment>
            )
          } else if (over?.sEventId === '0-1') {
            // For Playing 11
            return (
              <React.Fragment key={`comm${over?.sEventId}`}>
                <CommentaryCommonBox
                  className="mt-3"
                  id={`${over?._id}${over?.sOver}${over?.nInningNumber}`}
                  title={`${over?.oTeamA?.sTeam} Playing XI`}
                >
                  {over?.oTeamA?.sPlayers}
                </CommentaryCommonBox>
                <CommentaryCommonBox
                  id={`${over?._id}${over?.sOver}${over?.nInningNumber}`}
                  title={`${over?.oTeamB?.sTeam} Playing XI`}
                >
                  {over?.oTeamB?.sPlayers}
                </CommentaryCommonBox>
              </React.Fragment>
            )
          } else if (over?.eEvent === 'to' && over?.sCommentary) {
            // for Toss detail
            return (
              <React.Fragment key={`comm${over?.sEventId}`}>
                <CommentaryCommonBox className="mt-3" title={'Toss Detail'}>
                  {over?.sCommentary}
                </CommentaryCommonBox>
              </React.Fragment>
            )
          } else {
            return null
          }
        })}
      </section>
    </>
  )
}

Commentary.propTypes = {
  data: PropTypes.array,
  id: PropTypes.string,
  inning: PropTypes.array
}

export default Commentary
